import React, { useEffect } from 'react'; // لا حاجة لـ useState هنا
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { HelpCircle, Loader2 } from 'lucide-react'; // أضفنا أيقونة للتحميل
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion.jsx"; // تأكد أن الامتداد .jsx
import { useDispatch, useSelector } from 'react-redux';
import { fetchFaq } from '../rtk/faq-slice.js'; // تأكد أن الامتداد .js
// i18n يتم استيراده تلقائيًا من خلال useTranslation، لا حاجة لاستيراده هنا

const FAQ = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const dispatch = useDispatch();
    // جلب الحالة الكاملة من الـ slice
    const { faq, status, error } = useSelector((state) => state.faq);

    useEffect(() => {
        // جلب البيانات فقط إذا لم يتم جلبها من قبل
        if (status === 'idle') {
            dispatch(fetchFaq());
        }
    }, [dispatch, status]);

    // --- دالة لعرض المحتوى بناءً على الحالة ---
    const renderContent = () => {
        // 1. حالة التحميل
        if (status === 'loading' || status === 'idle') {
            return (
                <div className="flex flex-col items-center justify-center text-center py-12">
                    <Loader2 className="w-12 h-12 text-amber-500 animate-spin" />
                    <p className="mt-4 text-lg text-gray-600">{t('faq.loading', 'Loading Questions...')}</p>
                </div>
            );
        }

        // 2. حالة وجود خطأ
        if (status === 'failed') {
            return (
                <div className="text-center py-12 text-red-600">
                    <h4 className="text-xl font-semibold">{t('faq.errorTitle', 'An Error Occurred')}</h4>
                    <p>{error || t('faq.errorMessage', 'Could not load the frequently asked questions.')}</p>
                </div>
            );
        }

        // 3. حالة عدم وجود أسئلة بعد نجاح الجلب
        if (status === 'succeeded' && (!faq || faq.length === 0)) {
            return (
                <div className="text-center py-12 text-gray-500">
                    <HelpCircle className="mx-auto h-12 w-12 text-gray-400" />
                    <p className="mt-4 text-lg">{t('faq.noQuestions', 'No frequently asked questions available at the moment.')}</p>
                </div>
            );
        }

        // 4. حالة النجاح ووجود بيانات
        if (status === 'succeeded' && faq.length > 0) {
            return (
                <Accordion type="single" collapsible className="w-full space-y-4">
                    {faq.map((item, index) => (
                        <motion.div
                            key={item.id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <AccordionItem value={`item-${item.id}`} className="border-b border-gray-200 bg-white shadow-sm rounded-lg px-6 transition-shadow hover:shadow-md">
                                <AccordionTrigger className="text-lg font-semibold text-gray-800 text-left hover:no-underline">
                                    {item[`question_${currentLanguage}`] || item.question_en}
                                </AccordionTrigger>
                                <AccordionContent className="pt-2 text-gray-600 leading-relaxed">
                                    {item[`answer_${currentLanguage}`] || item.answer_en}
                                </AccordionContent>
                            </AccordionItem>
                        </motion.div>
                    ))}
                </Accordion>
            );
        }

        // حالة احتياطية
        return null;
    };


    return (
        <section id="faq" className="py-20 bg-gradient-to-br from-slate-50 to-gray-100">
            <div className="container mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 flex items-center justify-center gap-3">
                        <HelpCircle className="w-10 h-10 text-amber-600" />
                        {t('faq.title')}
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        {t('faq.subtitle')}
                    </p>
                </motion.div>

                <div className="max-w-3xl mx-auto">
                    {renderContent()}
                </div>
            </div>
        </section>
    );
};

export default FAQ;